import React from "react";
import { graphql } from "gatsby";
import PageWrapper from "@modules/Layout/PageWrapper";
import HeadSeo from "@modules/seo/components/HeadSeo";
import ProductCategory from "@modules/ProductCategory/components";
import { CategorySlugContext } from "@modules/ProductCategory/context";
import { useLocation } from "@reach/router";

interface IProps {
  params: {
    slug: string;
  };
  pageContext: {
    slug: string;
  };
  location: {
    pathname: string;
  };
  data: {
    strapiCategoryPage: {
      id: string;
      seo: {
        metaTitle: string;
        metaDescription: string;
        keywords: string;
        meta_image: {
          url: string;
          formats: {
            small: {
              url: string;
            };
          };
        };
      };
    };
  };
}

const CategoryPage: React.FC<IProps> = (props) => {
  const slug = props.pageContext.slug;
  const location = useLocation();
  const pathname = location ? location.pathname : "";

  const { metaTitle, metaDescription, keywords, meta_image } =
    props?.data?.strapiCategoryPage?.seo;

  return (
    <PageWrapper>
      <HeadSeo
        title={metaTitle}
        description={metaDescription}
        pathname={pathname}
        keywords={keywords}
        image={meta_image?.url}
      />
      <CategorySlugContext.Provider value={slug}>
        <ProductCategory />
      </CategorySlugContext.Provider>
    </PageWrapper>
  );
};

export const query = graphql`
  query CategoryPageQuery($slug: String!) {
    strapiCategoryPage(slug: { eq: $slug }) {
      id
      seo {
        metaTitle
        metaDescription
        keywords
        meta_image {
          url
          formats {
            small {
              url
            }
          }
        }
      }
    }
  }
`;

export default CategoryPage;
